import ModuleTypes from "../constants/ModuleTypes"
import type { BuildUrlDataOutput } from "./buildModuleUrlData"

const GRAPHQL_MODULE_TYPES = [
  ModuleTypes.BOOK_TEST_DRIVE,
  ModuleTypes.PRICE_ALERT,
  ModuleTypes.CUSTOM,
  ModuleTypes.CALL,
  ModuleTypes.ROUTER,
]

/**
 * @param {ModuleTypes} moduleType
 */
const throwModuleTypeNotSupported = (moduleType: ModuleTypes) => {
  throw new Error(`moduleType not supported: ${moduleType}`)
}

/**
 * @param {ModuleTypes} moduleType
 */
const getModuleSpecificPath = (moduleType: ModuleTypes): string => {
  switch (moduleType) {
    case ModuleTypes.TRADE_IN:
      return "trade_in_valuations/new"
    case ModuleTypes.SIMILAR_CARS:
      return "similar_cars/fetch"
    default:
      throwModuleTypeNotSupported(moduleType)
      return ""
  }
}

/**
 * Builds the url used to load module in iframe
 */
const buildModuleUrl = (opts: BuildUrlDataOutput): string | null => {
  // Make sure no undefined stuff ends up in the iframe url
  Object.keys(opts).forEach(
    (key) =>
      typeof opts[key as keyof BuildUrlDataOutput] === "undefined" &&
      delete opts[key as keyof BuildUrlDataOutput]
  )

  const { moduleType, host, cId, refUrl, ...opt } = opts

  // We do not need a module URL for the new book test drive module
  // (or price monitoring) as all requests are made through graphql
  if (GRAPHQL_MODULE_TYPES.includes(moduleType)) return null

  let url = `${host}/widgets/${getModuleSpecificPath(moduleType)}`
  url += `?c_id=${encodeURIComponent(cId)}`
  url += `&car_url=${encodeURIComponent(refUrl)}`
  // Adds the rest of object keys to the url
  Object.keys(opt).forEach((key) => {
    const value = opt[key as keyof typeof opt]
    if (typeof value === "undefined") return
    if (value === null) return
    url += `&${key}=${encodeURIComponent(value)}`
  })

  return url
}

export default buildModuleUrl
